export interface IProductMeasurement {
	'measurements.length'?: string;
	'measurements.shoulders'?: string;
	'measurements.chest'?: string;
	'measurements.waist'?: string;
	'measurements.hips'?: string;
	'measurements.sleeve'?: string;
	'measurements.crotch'?: string;
	'measurements.leg'?: string;
	'measurements.hem'?: string;
}

export type TTabData = {
	matrix: string[][];
	firstRowIsHeader: boolean;
	firstColumnIsHeader: boolean;
};

export enum ETabType {
	SIZE = 'size',
}

export interface ISizeGuideTab {
	heading: string;
	data?: TTabData;
}